import $ from 'jquery'
import Backbone from '@polleverywhere/backbone'
import env from '@polleverywhere/core/lib/env'
import { html, render } from 'lit-html'

import '@polleverywhere/pe-text-field'

const isAccountSubmittable = function (state, options) {
  if (state.has('accountFound')) {
    const accountFound = state.get('accountFound')
    return options.requiresAccount ? !!accountFound : !accountFound
  } else {
    return true
  }
}

const triggerCanSubmit = function () {
  const sso = this.state.get('sso') || {}
  const accountSubmittable = isAccountSubmittable(this.state, this.options)
  this.trigger('state', { accountSubmittable: !sso.force_saml && accountSubmittable })
}

const handleSSO = function (state, data = {}) {
  if (data.sso) {
    const $ssoLoginText = $('<p>').append(data.saml_hint)

    this.trigger('view:action', 'view:samlHint')

    this.$('.component-auth__sso').append($ssoLoginText)
  } else {
    this.$('.component-auth__sso').empty()
  }
}

const handleAccountFound = function (state, accountFound) {
  if (accountFound !== null) {
    if (this.options.requiresAccount && !accountFound) {
      this.toggleError('Account does not exist')
    } else if (!this.options.requiresAccount && accountFound) {
      this.toggleError('Account already exists')
    }
  }
}

/**
 * Fire off a check of the account info (existance and SSO details)
 * Only do this if we're not currently submitting the authentication to the server
 */
const testUsername = function () {
  if (this.field.validate()) {
    const identifier = this.$input.val().trim()
    this._checkingAccount = identifier
    this.state.set({
      sso: false,
      accountFound: null
    })

    getAccountInfo(identifier).then((info) => {
      // Use the result only if we didn't start checking another while in-flight
      if (this._checkingAccount === identifier) {
        this._checkingAccount = null
        this.state.set({
          sso: info || false,
          accountFound: info.exists
        })
      }
    })
  }
}

const getAccountInfo = function (identifier) {
  return Backbone.ajax({
    url: env.get('api_url').path('/api/users/check').toString(),
    data: {
      login_or_email: identifier
    }
  })
}

export default class UserInput extends Backbone.View {
  get className () {
    return 'component-auth__account-field'
  }

  get $input () {
    return this.$('input')
  }

  get field () {
    return this.$('pe-text-field')[0]
  }

  get name () {
    return 'username'
  }

  get events () {
    return {
      'click .component-auth__sso a': () =>
        this.trigger('view:action', 'click:samlHint', null, { immediate: true })
    }
  }

  initialize (options) {
    this.checkingAccount = null
    this.options = options
    this.state = new Backbone.Model()

    this.listenTo(this.state, 'change:sso', handleSSO.bind(this))
    this.listenTo(this.state, 'change:accountFound', handleAccountFound.bind(this))
    this.listenTo(this.state, 'change:sso change:accountFound', triggerCanSubmit.bind(this))
  }

  toggleError (error) {
    this.field.error = error
  }

  validate (options = { offline: false }) {
    const accountSubmittable = isAccountSubmittable(this.state, this.options)
    const identifierValid = this.field.validate({ silent: true })

    return accountSubmittable && identifierValid
  }

  render () {
    render(html`
    <pe-text-field
      required
      name=${this.name}
      placeholder=${this.options.placeholder}
      type=${this.options.type || 'text'}
      minLength=3
      pattern='.{3,255}'
      @invalid=${(...args) => this.trigger('error', ...args)}
      @change=${() => testUsername.call(this)}
    ></pe-text-field>
    <div class='component-auth__sso'></div>
    `, this.el)

    return this
  }
}
